import { useMutation } from '@apollo/client';

import RaiseProformaByBillingCyclesMutation from '@/graphql/contracts/raiseProformaByBillingCycles.mutation.gql';
import { apolloClientContracts } from '@/apollo/clients/contracts.apollo';
import { RaiseProformaByBillingCycles, RaiseProformaByBillingCyclesVariables }
  from '@/graphql/contracts/_generated_/raiseProformaByBillingCycles.mutation';
import { ResultEnum } from '@/graphql/contracts/_generated_/contracts';
import { notificationService } from '@/services/notification/notification.client';

export default function useRaiseProformaByBillingCycles(contractId: UUID) {

  const [_raiseProformaByBillingCycles, { loading }] = useMutation<
  RaiseProformaByBillingCycles, RaiseProformaByBillingCyclesVariables>(
    RaiseProformaByBillingCyclesMutation,
    {
      client: apolloClientContracts,
      onError: (err) => notificationService.open({
        title: 'Error',
        text: err.message,
        type: 'danger'
      }),
      onCompleted: ({ raiseProformaByBillingCycles }) => {
        if (raiseProformaByBillingCycles.code === ResultEnum.SUCCESS) {
          notificationService.open({
            text: 'Your proforma has been Queued, please check the history shortly to check for success or failure',
            title: 'Raise Proforma By Billing Cycles',
            type: 'warning'
          });
        }
        else {
          notificationService.open({
            text: 'Something went wrong. Try to reload the page and raise proforma again',
            title: 'Raise Proforma By Billing Cycles',
            type: 'warning'
          });
        }
      }
    }
  );

  const raiseProformaByBillingCycles = () => {
    _raiseProformaByBillingCycles({
      variables: {
        contractID: contractId
      }
    });
  };

  return {
    raiseProformaByBillingCycles,
    isLoadingRaiseProformaByBillingCycles: loading,
  } as const;
}
